import { getSupabaseBaseUrl, getSupabasePublishableKey } from '@/lib/selfHostedUrls';
import { createGovernedBrowserClient } from './portalClientFactory';

const SUPABASE_URL = getSupabaseBaseUrl();
const SUPABASE_PUBLISHABLE_KEY = getSupabasePublishableKey();

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createGovernedBrowserClient(
  'hire',
  SUPABASE_URL,
  SUPABASE_PUBLISHABLE_KEY,
);
